import React, { useState, useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';

function AutoRefreshTable(props) {
  const { getData, id, loading, sortDirection, sortField, searchText, filters } = props;
  const [ intervalActive, setIntervalActive ] = useState(false);
  const [ intervalTime, setIntervalTime ] = useState(10000);
  const options = Array.from([5, 10, 30, 60, 180, 300, 600], x => { return { value: x, display: x.toString() } });
  const interval = useRef(null);

  useEffect(() => {

    if (intervalActive) {
      interval.current = setInterval(() => {
        getData(1, sortField, sortDirection, searchText, filters);
      }, intervalTime);
    }

    if (! intervalActive) {
      clearInterval(interval.current);
    }

    return () => {
      clearInterval(interval.current);
    }
  }, [ intervalActive, intervalTime, sortField, sortDirection, searchText, filters, getData ]);

  return (
    <div className="table-auto-refresh-control">
      <FormattedMessage id="components.layout.table.autoRefreshTable.autoRefreshText" />
      <label className="custom-toggle">
        <input
          id={`auto-refresh-input-table-${id}`}
          type="checkbox"
          name="auto_refresh_table"
          checked={ intervalActive }
          onChange={ event => { setIntervalActive(!intervalActive) } }
          disabled={loading > 0}
        />
        <span className="custom-toggle-slider rounded-circle" />
      </label>
      {
        intervalActive &&
        <>
          <FormattedMessage id="components.layout.table.autoRefreshTable.interval" />
          <select
            id={`auto-refresh-time-input-table-${id}`}
            className="form-control form-control-sm auto-refresh-interval"
            aria-label="auto_refresh_time_table"
            value={intervalTime / 1000}
            onChange={e => setIntervalTime( e.target.value * 1000 )}
            disabled={loading > 0}
          >
            {
              options.map((option) => (
                <option value={option.value} key={option.value} className="d-flex justify-content-center text-center align-items-center">
                  { option.display }
                </option>
              ))
            }
          </select>
        </>
      }
    </div>
  );
}

export { AutoRefreshTable }
